/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { Button } from 'sarsaparilla';
import PropTypes from 'prop-types';
import ProgressBar from './ProgressBar';

export default class RatingBreakout extends React.PureComponent {
    static propTypes = {
        total: PropTypes.number,
        value: PropTypes.string,
        starCounts: PropTypes.shape({
            1: PropTypes.number,
            2: PropTypes.number,
            3: PropTypes.number,
            4: PropTypes.number,
            5: PropTypes.number,
        }),
        onChange: PropTypes.func,
    };

    buildBreakout() {
        const { total, starCounts, onChange } = this.props;
        const breakout = [];
        for (let i = 5; i > 0; i--) {
            const ratings = starCounts[i.toString()];
            breakout.push(
                <div key={`rating-breakout-line-${i}`} className="rating-breakout-line">
                    <Button
                        appearance={'link'}
                        isDisabled={ratings < 1}
                        onClick={() => onChange(`${i}`)}
                        gaTrackingId="312793311875"
                    >
                        <span data-var="stars-total">{i}</span> &nbsp; stars
                    </Button>
                    <ProgressBar total={total} interval={ratings} />
                    <span className="ratings">{ratings}</span>
                </div>
            );
        }
        return breakout;
    }

    render() {
        const { value, onChange } = this.props;
        return (
            <div className="rating-breakout-wrapper">
                {value && (
                    <div className="clear-rating-wrap">
                        <div>
                            Showing Reviews with:{' '}
                            <strong>
                                <span data-var="star-count">{value}</span> Stars
                            </strong>
                        </div>
                        <Button
                            appearance="link"
                            onClick={() => onChange('')}
                            gaTrackingId="772062775358"
                        >
                            {' '}
                            Remove Filter{' '}
                        </Button>
                    </div>
                )}
                {this.buildBreakout()}
            </div>
        );
    }
}
